import AnalyticHeader from "./AnalitycHeader";
export default AnalyticHeader